import { useEffect, useState } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '../../components/UI'
import { materialCalculatorApi } from '../../services/materialCalculator'

export default function MCCatalogPage() {
  const [items, setItems] = useState([])

  useEffect(() => { materialCalculatorApi.listCatalog().then(setItems).catch(() => setItems([])) }, [])

  return (
    <Card>
      <CardHeader><CardTitle>Catálogo de materiales</CardTitle></CardHeader>
      <CardContent>
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50"><tr><th className="px-3 py-2 text-left">SKU</th><th className="px-3 py-2 text-left">Nombre</th><th className="px-3 py-2">Unidad</th><th className="px-3 py-2">Precio</th></tr></thead>
          <tbody>
            {items.map((i) => <tr key={i.id} className="border-t"><td className="px-3 py-2">{i.sku}</td><td className="px-3 py-2">{i.name}</td><td className="px-3 py-2 text-center">{i.unit}</td><td className="px-3 py-2 text-right">{Number(i.unitPrice).toLocaleString()}</td></tr>)}
          </tbody>
        </table>
      </CardContent>
    </Card>
  )
}
